var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonScatterHaike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#FCAF3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140 93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -147L103.9 -103.9L147 0L103.9 103.9L0 147L-103.9 103.9L-147 0L-103.9 -103.9Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355 548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -97L68.6 -68.6L97 0L68.6 68.6L0 97L-68.6 68.6L-97 0L-68.6 -68.6Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -134L94.8 -94.8L134 0L94.8 94.8L0 134L-94.8 94.8L-134 0L-94.8 -94.8Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(867 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -125L88.4 -88.4L125 0L88.4 88.4L0 125L-88.4 88.4L-125 0L-88.4 -88.4Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770 554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -134L94.8 -94.8L134 0L94.8 94.8L0 134L-94.8 94.8L-134 0L-94.8 -94.8Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -63L44.5 -44.5L63 0L44.5 44.5L0 63L-44.5 44.5L-63 0L-44.5 -44.5Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScatterHaike);
export default __webpack_public_path__ + "static/media/polygon-scatter-haike.7df4d77a0ee7eb415f741e914ee0d215.svg";
export { ForwardRef as ReactComponent };